module.exports = __webpack_public_path__ + "std/img/deposit-text.7d599b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/daily-draw/deposit-text.png
// module id = Z9Vu
// module chunks = 0 5